import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidatePreviewCounterpartyBankResponse from "./customerRefundCandidatePreviewCounterpartyBankResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePreviewTransferRefundPaymentResponse {
  @observable
  @Type(() => CustomerRefundCandidatePreviewCounterpartyBankResponse)
  counterpartyBank!: CustomerRefundCandidatePreviewCounterpartyBankResponse;

  /**
   * Refund counterparty name.
   */
  @observable
  counterpartyName?: string;

  /**
   * Refund counterparty street address.
   */
  @observable
  counterpartyStreetAddress?: string;

  /**
   * Refund counterparty city address.
   */
  @observable
  counterpartyCityAddress?: string;

  /**
   * Refund counterparty country ID.
   */
  @observable
  counterpartyCountryId?: string;

  /**
   * Additional AV message.
   */
  @observable
  additionalAvMessage?: string;
}
